module.exports = __webpack_public_path__ + "static/media/G_glass.87037255.gif";